import { MenuOptionType } from "@dexteel/mesf-core";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import BlockIcon from "@mui/icons-material/Block";
import BookmarkAddIcon from "@mui/icons-material/BookmarkAdd";
import BookmarkRemoveIcon from "@mui/icons-material/BookmarkRemove";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { TreeParameters } from "../models/TreeParameter";

type Props = {
	setDelayNodeSelectedInTree: (node: any | null) => void;
	onNodeSelect: (node: TreeParameters) => void;
	onRequestAdd: () => void;
	onRequestDelete: (node: TreeParameters) => void;
	onToggleQuickButton: (node: TreeParameters) => void;
	onToggleActive: (node: TreeParameters) => void;
	handleMoveUp: ({ delayCodeId }: { delayCodeId: number }) => void;
	handleMoveDown: ({ delayCodeId }: { delayCodeId: number }) => void;
};

export const useDelayCodeOptionsFunctions = ({
	setDelayNodeSelectedInTree,
	onNodeSelect,
	onRequestAdd,
	onRequestDelete,
	onToggleQuickButton,
	onToggleActive,
	handleMoveUp,
	handleMoveDown,
}: Props) => {
	const getMenuOptions = (data: TreeParameters) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Delay Code",
				key: "new_delay_code",
				onClick: () => {
					if (!data) {
						setDelayNodeSelectedInTree(null);
					}
					onRequestAdd();
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Delay Code",
					key: "edit_delay_code",
					disabled: !data.isEditable,
					onClick: () => {
						onNodeSelect(data);
					},
					icon: <EditIcon />,
				},
			]);
			if (!data.droppable) {
				options = options.concat([
					{
						name: "Delete Delay Code",
						key: "delete_delay_code",
						disabled: !data.isEditable,
						onClick: () => {
							onRequestDelete(data);
						},
						icon: <DeleteIcon />,
					},
				]);
			}
			options = options.concat([
				{
					name: data.quickButtonEnabled
						? "Remove 'Quick' button"
						: "Add 'Quick' button",
					key: "toggle_quick_button",
					disabled: !data.isEditable,
					onClick: () => {
						onToggleQuickButton(data);
					},
					icon: data.quickButtonEnabled ? (
						<BookmarkRemoveIcon />
					) : (
						<BookmarkAddIcon />
					),
				},
				{
					name: data.isActive ? "Set as 'Not active'" : "Set as 'Active'",
					key: "toggle_active",
					disabled: !data.isEditable,
					onClick: () => {
						onToggleActive(data);
					},
					icon: data.isActive ? <BlockIcon /> : <CheckCircleOutlineIcon />,
				},
				{
					name: "Move Up",
					key: "move_up_delay_code",
					disabled: data.isAtTop,
					onClick: () => {
						handleMoveUp({ delayCodeId: data.id });
					},
					icon: <ArrowUpwardIcon />,
				},
				{
					name: "Move Down",
					key: "move_down_delay_code",
					disabled: data.isAtBottom,
					onClick: () => {
						handleMoveDown({ delayCodeId: data.id });
					},
					icon: <ArrowDownwardIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
